// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1574":"a358174b30e5e2c4","2888":"e746f2db34914389"}[chunkId] + ".css";
};